export const GET_DASHBOARD_SERVICES = "GET_DASHBOARD_SERVICES";
export const SHOW_LOADER = "SHOW_DASHBOARD_SERVICE_LOADER";
export const GET_USER_DASHBOARD_STATUS = "GET_USER_DASHBOARD_STATUS"

export interface IDashboardServiceState {
    dashboardServices?: DashboardService[];
    isLoading: boolean;
    userDashboardstatus?: string;
}

export interface DashboardService {
    categoryName?: string;
    categoryText?: string;
    lastScanDate?: string;
    lastUpdateDate?: string;
    active?: boolean;
    newAlertCount?: number;
    categoryUrl?: string;
    categoryIconClass?: string;
}

export interface GetDashboardServiceAction {
    type: "GET_DASHBOARD_SERVICES";
    dashboardServices: DashboardService[];
}
export interface ShowAction {
    type: "SHOW_DASHBOARD_SERVICE_LOADER";
    isLoading: boolean;
}
export interface GetUserDashboardStatus {
    type: "GET_USER_DASHBOARD_STATUS";
    userDashboardstatus?: string;
}
export type KnownAction = GetDashboardServiceAction | ShowAction | GetUserDashboardStatus;

// GetAllTUServiceWithLabel
export interface ITUServiceState {
    tuServices?: ITUService[];
    loadingServices: boolean;
}

export const REQUEST_ALL_TU_SEVICES = "REQUEST_ALL_TU_SEVICES";
export const RECEIVE_ALL_TU_SEVICES = "RECEIVE_ALL_TU_SEVICES";

export interface IRequestAllTUService {
    type: typeof REQUEST_ALL_TU_SEVICES;
}

export interface IReceiveAllTUService {
    type: typeof RECEIVE_ALL_TU_SEVICES;
    tuServices?: ITUService[];
}

export type TUServiceAction = IRequestAllTUService | IReceiveAllTUService;

export interface ITUService {
    displayName?: string;
    code?: string;
}
